import Vue from 'vue';
import getConfig from '@/utility/getConfig';
import { workerPostMessage, workerOnMessage } from '@/utility/workerMessage';
import getParams from '@/utility/getParams';
import createTranslationsProxy from '@/utility/translationsProxy';
import App from './App';
import router from './router';
import store from './store';
import i18n from './i18n';

window.lotteryWorker = null;

(async () => {
  try {
    store.dispatch('setScreenSize', window.innerWidth);
    const params = await getParams();
    const configSettings = {};
    const isNewDeviceManagement = !!params.appRunUuid || !!params.systemsSdk;
    store.commit('SET_QUERY_PARAMS', params);
    let desktopApp = false;
    if (params.layout) {
      store.commit('SET_LAYOUT', params.layout);
    }

    if (params.windowTitle || isNewDeviceManagement) {
      configSettings.includeLocalAdapter = params.windowTitle || 'NumbersBetting';
      configSettings.useSystemsSdk = isNewDeviceManagement;
      configSettings.appRunUuid = params.appRunUuid;
      configSettings.sendAppHeartbeat = true;
      if (params.environment) {
        configSettings.environment = params.environment;
      }
      store.commit('SET_LAYOUT', 'RetailLayout');
      desktopApp = true;
      if (params.windowTitle) {
        document.title = params.windowTitle;
      }
    }
    const config = await getConfig({ ...params.configData, ...configSettings });
    if (config) {
      config.locale = params.configData?.locale || config.language || config.locale;
      store.commit('SET_CONFIG', config);
      if (store.state.usePackageTranslations) {
        // NPM PACKED TRANS
        const translationsPackage = await import('@nsftx/i18n-games-lottery');
        const translations = await translationsPackage.exportTranslations(config.locale, {
          companyName: config.companyName || '',
          companyUuid: config.tenantId,
          env: config.environment,
        });
        const proxyTranslations = createTranslationsProxy(translations);

        store.commit('SET_TRANSLATIONS', proxyTranslations);
      } else {
        // STANDARD LOCAL TRANS
        store.commit('SET_TRANSLATIONS', (await i18n(config.locale)).default);
      }
    } else {
      console.error('NumbersBetting: Error getting config!');
      return;
    }
    new Vue({
      router,
      store,
      mounted() {
        if (!window.lotteryWorker && this.$store.getters.layout === 'RetailLayout') {
          if (!localStorage.getItem('reload') && !desktopApp) {
            localStorage.setItem('reload', 'true');
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          } else {
            localStorage.removeItem('reload');
            window.lotteryWorker = new Worker('/retailWorker.js');
            workerOnMessage(store);
            workerPostMessage('url', {
              url: `${process.env.VUE_APP_API_BASEURL}/api/status`,
              header: config.tenantId,
            });
          }
        }
      },
      beforeDestroy() {
        if (window.lotteryWorker && this.$store.getters.layout === 'RetailLayout') {
          window.lotteryWorker.terminate();
        }
      },
      render: (h) => h(App),
    }).$mount('#app');
  } catch (e) {
    console.log('some error');
  }
})();
